import React from 'react';
import {Search as SearchIcon} from '@material-ui/icons';
import { alpha, styled } from "@material-ui/system"; 
import { InputBase } from '@material-ui/core';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Search = styled('div')(({ theme }) => ({
	position: 'relative',
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(theme.palette.common.white, 0.15),
	'&:hover': {
	  backgroundColor: alpha(theme.palette.common.white, 0.25),
	},
	marginRight: theme.spacing(2),
	marginLeft: 0,
	// width: '100%',
	[theme.breakpoints.up('sm')]: {
	//   marginLeft: theme.spacing(3),
	  width: 'auto',
	},
      }));
      
      const SearchIconWrapper = styled('div')(({ theme }) => ({
	padding: theme.spacing(0, 2),
	height: '100%',
	position: 'absolute',
	pointerEvents: 'none',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
      }));

      const StyledInputBase = styled(InputBase)(({ theme }) => ({
	color: 'inherit',
	'& .MuiInputBase-input': {
	  padding: theme.spacing(1, 1, 1, 0),
	  // vertical padding + font size from searchIcon
	  paddingLeft: `calc(1em + ${theme.spacing(4)})`,
	  transition: theme.transitions.create('width'),
	  width: '100%',
	  [theme.breakpoints.up('md')]: {
	    width: '20ch',
	  },
	},
      }));
      

export default function Busqueda() {

	const [patron, setPatron] = useState("");
	const initialRender = React.useRef(true);
	let navigate = useNavigate();
	const navigateRef = React.useRef(navigate);

	useEffect(() => {
		navigateRef.current = navigate;
	}, [navigate]);

	async function handleSubmit(event) {
		setPatron(event.target.value)
	      }
	useEffect(() => {
		if (initialRender.current) {
			initialRender.current = false;
			return;
		}
		const normalizedPattern = patron.trim();
		if (normalizedPattern.length >= 3) {
			navigateRef.current(`/searchDrawer/${encodeURIComponent(normalizedPattern)}`, { replace: true });
		} else if (normalizedPattern.length === 0) {
			navigateRef.current(`/searchDrawer`, { replace: true });
		}
	}, [patron])
	

  return (
	<Search sx={{mr:0, mt:1}}>
	<SearchIconWrapper>
		<SearchIcon />
	</SearchIconWrapper>
	<StyledInputBase
		placeholder="Buscar (mín. 3 caracteres)…"
		inputProps={{ 'aria-label': 'Buscar productos por código o nombre; mínimo 3 caracteres' }}
		onChange={handleSubmit}
		value={patron}
	/>
	</Search>
  )

  }
